export default __webpack_public_path__ + "static/media/round-pin.74ac3011.png";